module.exports = "data:image/png;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICIwNzVjMDU2ZDMxODI2ODAyOTg3ZjllM2FhNDZkNDg2OC5wbmciOw=="